import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import { LinkButton } from '@nobia/zeus-components/lib/buttons'
import { SubHeadline } from '@nobia/zeus-components/lib/text'
import { Container, Row, Column } from '@nobia/zeus-components/lib/grid'
import LoginModal from '../login-modal/LoginModal'
import { cdnImage } from '../../utils'

const image = cdnImage(require('../../assets/close.svg'))

const Modal = styled.div`
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
`

const ModalDialog = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
`

const ModalContent = styled.div`
  position: relative;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  outline: 0;
  -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  min-height: 100vh;
  border-radius: 0;
`

const ModalHeader = styled.div`
  display: block;
  padding: 15px;
  text-align: right;
`

const CloseButton = styled.img`
  width: 7%;
  vertical-align: middle;
  border: 0;
`

const ModalBody = styled.div`
  position: relative;
  display: block;
  padding: 15px;
`

const AddToMyAccountButton = styled(LinkButton)`
  margin: 20px 0;
`

const CustomLabel = styled.label`
  width: 100%;
  display: block;
  line-height: 21px;
`

const HeaderColumn = styled(Column)`
  padding: 0 20px 0 20px;
`

class ReminderModal extends Component {
  state = {
    showLoginModal: false,
  }

  toggleLoginModal = () => {
    this.setState({ showLoginModal: !this.state.showLoginModal })
  }

  render() {
    if (this.props.open) {
      return (
        <Modal>
          <ModalDialog>
            <ModalContent>
              <ModalHeader>
                <CloseButton src={image} onClick={this.props.handleClose} />
              </ModalHeader>
              <ModalBody>
                <Container>
                  <Row>
                    <HeaderColumn xs={12}>
                      <SubHeadline>
                        Don&#39;t forget to add the products to your Magnet
                        account
                      </SubHeadline>
                    </HeaderColumn>
                  </Row>
                  <Row>
                    <Column xs={12}>
                      <CustomLabel>
                        Login, or create a new account in seconds, and your
                        favourite products will be saved so you can always can
                        find them
                      </CustomLabel>
                    </Column>
                  </Row>
                  <Row>
                    <Column xs={12}>
                      <AddToMyAccountButton
                        kind={'primary'}
                        size={'large'}
                        onClick={this.toggleLoginModal}
                      >
                        Add to my account
                      </AddToMyAccountButton>
                    </Column>
                  </Row>
                  <LoginModal
                    open={this.state.showLoginModal}
                    handleClose={this.toggleLoginModal}
                  />
                </Container>
              </ModalBody>
            </ModalContent>
          </ModalDialog>
        </Modal>
      )
    }
    return <div />
  }
}

ReminderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
}

export default ReminderModal
